import {
  Avatar,
  Box,
  BoxList,
  Button,
  Icon,
  Spinner,
  Text,
} from '@factorialco/deprecated-design-system'
import { SignerStampsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

interface Props {
  additionalSigners: string[]
  removeRecipient: () => void
  removeSigner: (accessId: string) => void
  showRecipient?: boolean
}

const SignersList = ({
  additionalSigners,
  removeRecipient,
  removeSigner,
  showRecipient = true,
}: Props) => {
  const { data, loading } = useQuery(SignerStampsDocument, {
    variables: { signerIds: additionalSigners },
    skip: additionalSigners.length === 0,
  })

  const signers = data?.apiCore.accessesConnection.nodes ?? []

  if (loading) {
    return (
      <Box alignItems="center" justifyContent="center" padding="s12">
        <Spinner />
      </Box>
    )
  }

  return (
    <BoxList>
      {showRecipient && (
        <Box
          flexDirection="row"
          padding="s12"
          gap="s8"
          justifyContent="spaceBetween"
          alignItems="center"
        >
          <Box gap="s8" flexDirection="row" alignItems="center">
            <Box padding="s4" background="grey200" borderRadius={{ all: 'abs012' }}>
              <Icon.Large icon="user" />
            </Box>
            <Text.Normal weight="semibold">{i18n.t('split_documents.form.recipient')}</Text.Normal>
          </Box>
          <Button type="secondary" iconName="cross" onClick={removeRecipient} />
        </Box>
      )}
      {signers.map((signer, index) => (
        <Box
          key={signer.id}
          flexDirection="row"
          padding="s12"
          gap="s8"
          alignItems="center"
          justifyContent="spaceBetween"
          border={
            index !== 0
              ? {
                  top: {
                    width: 's1',
                    style: 'solid',
                    color: 'grey400',
                  },
                }
              : {}
          }
        >
          <Box gap="s8" flexDirection="row" alignItems="center">
            <Avatar label={signer.fullName} url={signer.avatar || ''} size="s40" />
            <Box>
              <Text.Normal weight="semibold">{signer.fullName}</Text.Normal>
              <Text.Normal size="100">
                {signer.employee?.referenceContract?.jobTitle ?? ''}
              </Text.Normal>
            </Box>
          </Box>
          <Button type="secondary" iconName="cross" onClick={() => removeSigner(signer.id)} />
        </Box>
      ))}
    </BoxList>
  )
}

export default SignersList
